'use strict';

var _asyncToGenerator = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var errCode = require('err-code');

var fromString = require('uint8arrays/from-string');

var browserStreamToIt = require('browser-readablestream-to-it');

var blobToIt = require('blob-to-it');

var itPeekable = require('it-peekable');

var all = require('it-all');

var map = require('it-map');

var utils = require('./utils.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var browserStreamToIt__default = /*#__PURE__*/_interopDefaultLegacy(browserStreamToIt);

var blobToIt__default = /*#__PURE__*/_interopDefaultLegacy(blobToIt);

var itPeekable__default = /*#__PURE__*/_interopDefaultLegacy(itPeekable);

var all__default = /*#__PURE__*/_interopDefaultLegacy(all);

var map__default = /*#__PURE__*/_interopDefaultLegacy(map);

function toAsyncIterable(_x) {
  return _toAsyncIterable.apply(this, arguments);
}

function _toAsyncIterable() {
  _toAsyncIterable = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(thing) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return thing;

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _toAsyncIterable.apply(this, arguments);
}

function normaliseContent(_x2) {
  return _normaliseContent.apply(this, arguments);
}

function _normaliseContent() {
  _normaliseContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
    var peekable, _yield$peekable$peek, value, done;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!utils.isBytes(input)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", toAsyncIterable(toBytes(input)));

          case 2:
            if (!(typeof input === 'string' || input instanceof String)) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", toAsyncIterable(toBytes(input.toString())));

          case 4:
            if (!utils.isBlob(input)) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return", blobToIt__default["default"](input));

          case 6:
            if (utils.isReadableStream(input)) {
              input = browserStreamToIt__default["default"](input);
            }

            if (!(Symbol.iterator in input || Symbol.asyncIterator in input)) {
              _context2.next = 27;
              break;
            }

            peekable = itPeekable__default["default"](input);
            _context2.next = 11;
            return peekable.peek();

          case 11:
            _yield$peekable$peek = _context2.sent;
            value = _yield$peekable$peek.value;
            done = _yield$peekable$peek.done;

            if (!done) {
              _context2.next = 16;
              break;
            }

            return _context2.abrupt("return", toAsyncIterable(new Uint8Array(0)));

          case 16:
            peekable.push(value);

            if (!Number.isInteger(value)) {
              _context2.next = 25;
              break;
            }

            _context2.t0 = toAsyncIterable;
            _context2.t1 = Uint8Array;
            _context2.next = 22;
            return all__default["default"](peekable);

          case 22:
            _context2.t2 = _context2.sent;
            _context2.t3 = _context2.t1.from.call(_context2.t1, _context2.t2);
            return _context2.abrupt("return", (0, _context2.t0)(_context2.t3));

          case 25:
            if (!(utils.isBytes(value) || typeof value === 'string' || value instanceof String)) {
              _context2.next = 27;
              break;
            }

            return _context2.abrupt("return", map__default["default"](peekable, toBytes));

          case 27:
            throw errCode__default["default"](new Error("Unexpected input: ".concat(input)), 'ERR_UNEXPECTED_INPUT');

          case 28:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _normaliseContent.apply(this, arguments);
}

function toBytes(chunk) {
  if (chunk instanceof Uint8Array) {
    return chunk;
  }

  if (ArrayBuffer.isView(chunk)) {
    return new Uint8Array(chunk.buffer, chunk.byteOffset, chunk.byteLength);
  }

  if (chunk instanceof ArrayBuffer) {
    return new Uint8Array(chunk);
  }

  if (Array.isArray(chunk)) {
    return Uint8Array.from(chunk);
  }

  return fromString.fromString(chunk.toString());
}

exports.normaliseContent = normaliseContent;